/**
 * 페이지네이션 관련 상수
 * 
 * API 호출 시 사용되는 page_size 값들을 중앙에서 관리합니다.
 */

/**
 * 기본 페이지 크기
 */
export const DEFAULT_PAGE_SIZE = 20;

/**
 * 대시보드 페이지 크기
 * 최근 항목들을 보여주기 위한 작은 크기
 */
export const DASHBOARD_PAGE_SIZE = 10;

/**
 * 플레이리스트 상세 페이지 트랙 목록 크기
 *
 * detail 페이지는 드래그 reorder·트랙 분리·일괄 편집을 위해 전체 트랙을 한 화면에
 * 표시해야 한다. 트랙 분리로 page_size를 넘기면 reorder 시 trackIds set 불일치로
 * 실패하므로 backend `PlaylistDetailTracksPagination`의 max(1000)에 맞춰 충분히 크게 잡는다.
 */
export const PLAYLIST_DETAIL_TRACKS_PAGE_SIZE = 1000;

/**
 * 플레이리스트 상세 페이지 로그 크기
 */
export const PLAYLIST_DETAIL_LOGS_PAGE_SIZE = 10;

/**
 * 플레이리스트 목록 페이지 — 백엔드 전체 로드 크기
 *
 * 목록 페이지는 검색·필터·정렬·순서변경(DnD)을 모두 클라이언트에서 처리하므로
 * 채널의 전체 플레이리스트를 한 번에 받아 클라이언트에서 페이지를 나눈다.
 * backend StandardResultsSetPagination의 max_page_size(100)에 맞춘다.
 */
export const PLAYLISTS_LIST_FETCH_SIZE = 100;

/**
 * 플레이리스트 목록 — 한 화면에 표시할 카드 수 (클라이언트 페이지네이션 단위)
 *
 * 그리드가 3열(lg)이므로 3의 배수로 잡아 마지막 행이 깔끔하게 채워지도록 한다.
 */
export const PLAYLISTS_PER_PAGE = 12;

/**
 * 트랙 목록 페이지 크기
 */
export const TRACKS_LIST_PAGE_SIZE = 50;

/**
 * 파일 목록 페이지 크기
 * 많은 파일을 한 번에 보여주기 위한 큰 크기
 */
export const FILES_LIST_PAGE_SIZE = 100;

